const CareMapprPrivacyDetails = () => {
  return (
    <div>
      <h2>CareMappr Privacy Policy</h2>

      <p>
        CareMappr Pty Ltd (ABN 20 669 095 550) is the operator of the CareMappr
        website [caremappr.com] and any related Android or iOS app (“<b>site</b>
        ”) (on its own or together with any Healthcare Identifier organization
        registered to access the My Health Record system). We realise that your
        personal information is sensitive, and we understand that you trust us
        to be very careful with your information. We respect your privacy and
        we're committed to protecting your personal information. That's why we
        abide by the National Privacy Principles in the Australian Privacy Act
        1988.
      </p>

      <p>
        We have provided this policy to explain how your information is
        collected, used and protected. By accessing the site or using services,
        you agree to be bound by the terms of this policy. We encourage you to
        read this policy carefully. We hope it will help you to make informed
        decisions about sharing your information with us.
      </p>

      <p>This policy covers the following areas:</p>

      <ol>
        <li>
          Your personal information: what we collect and hold and why we collect
          and hold it;
        </li>
        <li>
          Disclosure to third parties: why we might disclose your personal
          information and who we might disclose it to;
        </li>
        <li>
          Access, corrections and complaints: how you might access and correct
          if necessary the personal information we hold about you, and how
          complaints about any breach by us of the Australian Privacy Principles
          might be made and dealt with; and
        </li>
        <li>Our security measures.</li>
      </ol>

      <p>
        If you have any questions or concerns about our policy you can email us:
        <em> privacy@caremappr.com.au</em>
      </p>

      <h3>1. What information about me is collected?</h3>

      <p>
        We collect both personal and non-personal information about you.
        “Personal information” is information which can identify you and
        includes information you provide when you register on our site such as
        your name, contact details and, as applicable, Medicare number (for
        Individual Users) and registration number (for Health Care
        Practitioners). You are given choices when we ask for personal
        information and, whenever possible, we try to explain why we ask for
        information. You can always choose not to provide personal information,
        but this may mean that some of the site's features will not be
        available.
      </p>

      <p>
        The personal information we collect from you might also include
        “sensitive information”, including your health information from the My
        Health Record system (previously known as Personally Controlled
        Electronic Health Record (PCEHR)) and other information manually entered
        by you, or provided by your health care practitioner(s) or health care
        practitioner(s) organisation on the site. Sensitive information could
        also include genetic information and some biometric information.
      </p>

      <p>
        We use this personal information to verify your identity, provide you
        with the services you have requested, notify you of new or changed
        services, tailor the content you see on our site and to contact you as
        required. By providing us with this information, you are able to use
        features, health tools and content, to review and exchange health
        information with the persons that you permit to access your information
        on the site, such as your health care practitioner(s).
      </p>

      <p>
        <strong>User feedback</strong>
      </p>

      <p>
        From time to time we may ask you for feedback about our site. This
        information allows us to better understand the needs of our users and to
        gather information about health issues and trends. We store answers but
        these are not linked to identifying information about you and they will
        not be shared with third parties.
      </p>

      <p>
        <strong>Log information</strong>
      </p>

      <p>
        When you visit our site, our servers will collect log information. This
        information may include your page request, Internet Protocol (IP)
        address, browser type, browser language, the date and time of your
        request and one or more cookies that may uniquely identify your browser.
        Log information helps us to gather information about how our site is
        being used such as the pages visitors are viewing.
      </p>

      <p>
        <strong>Cookies</strong>
      </p>

      <p>
        We use cookies to make your use of our site and services as convenient
        as possible. Cookies do not personally identify you; they are pieces of
        information that a site transfers to your computer's hard disk for
        record-keeping purposes. We can also use cookies to monitor the amount
        of people using our site and how they are using it. You can set your
        browser to refuse cookies but this may mean you cannot log in or take
        full advantage of our site.
      </p>

      <h3>2. Will any information be used or disclosed?</h3>

      <p>
        Other than as referred to below, we will not use or disclose any
        personal information about you without your consent unless all
        identifying information about you has first been removed. There may be
        exceptional circumstances where this may not be possible, such as if
        disclosure is required by law, is necessary to protect our rights or
        property or any member of the public, or to lessen a serious threat to a
        person's health or safety.
      </p>

      <p>
        <b>
          If you do not wish for your information to be disclosed or used as
          referred to below, please deregister from the site and contact us as
          soon as possible at <em>privacy@caremappr.com.au</em>
          &nbsp;to let us know.
        </b>
      </p>

      <p>
        <strong>
          Registering and communicating with your health care
          practitioner(s){' '}
        </strong>
      </p>

      <p>
        When you register via the site you can, permit others, such as your
        health care practitioners(s), to access your personal and sensitive
        information on the site.
      </p>

      <p>
        <strong>Aggregate health information</strong>
      </p>

      <p>
        When you register via the site, you give us (and any Health Identifier
        organisation we are working with to access the My Health Record system)
        permission to download data about you from the My Health Record system
        to enhance the exchange of information between you and your health care
        practitioner(s).
      </p>

      <p>
        We may disclose aggregate health and sensitive information from the site
        to health researchers including for the purpose of identifying health
        patterns that could support health care practitioners recommending
        health interventions at an earlier stage. Whilst we would not disclose
        your identity details with this information, some of the information by
        its very nature could lead to a user being identified.
      </p>

      <p>
        <strong>Others uses</strong>
      </p>

      <p>
        We may use your personal and sensitive information on a de-identified
        basis for analysis, research and quality assurance and improvement
        purposes.
      </p>

      <p>
        We may provide your personal (contact) information to researchers who
        may wish to contact you regarding relevant research approved by a
        National Health and Medical Research Council (NHMRC) ethics committee.
      </p>

      <p>
        We may also disclose your personal and sensitive information to third
        party service providers (such as our IT service providers) to the extent
        necessary to provide services to us.
      </p>

      <p>
        <strong>Emails</strong>
      </p>

      <p>
        Email communication that you send to us via links on our site may be
        shared with others working with us in relation to the site.
      </p>

      <p>
        <strong>Third Party Links</strong>
      </p>

      <p>
        We may provide links to various third party sites. Any information you
        provide to third party sites will be governed under the terms of each
        site's privacy policy and terms of use. We accept no responsibility or
        liability whatsoever for the content, actions or policies of third party
        sites. The inclusion of links to third party sites on our site in no way
        constitutes an endorsement of the third party sites' content, actions or
        policies: you access them at your own risk.
      </p>

      <p>
        <strong>Transfer of personal information overseas</strong>
      </p>

      <p>
        We do not transfer personal information from the site to persons outside
        Australia.
      </p>

      <h3>3. Access, corrections and complaints</h3>

      <p>
        <strong>Access</strong>
      </p>

      <p>You may request access to the information we hold about you.</p>

      <p>
        <strong>Corrections</strong>
      </p>

      <p>
        We assume that the information we hold about you is accurate, complete
        and up-to-date. However, if you identify that any of the information is
        not accurate, complete or up-to-date, please contact us at{' '}
        <em>privacy@caremappr.com.au</em>&nbsp;so that we can update the
        information for you.
      </p>

      <h3>4. What if I want to make a complaint?</h3>

      <p>
        If you wish to complain about how we have handled your personal
        information, please contact our Privacy Officer:
      </p>

      <ol>
        <li>
          by e-mail: <em>privacy@caremappr.com.au</em>;
        </li>
      </ol>

      <p>We will endeavour to:</p>
      <ol>
        <li>
          provide an initial response to your query or complaint within 5
          business days; and
        </li>
        <li>resolve your query or complaint within 21 business days.</li>
      </ol>

      <p>
        If you are still not satisfied, you can contact the Australian Privacy
        Commissioner (see{' '}
        <a href="https://www.oaic.gov.au/contact-us">
          https://www.oaic.gov.au/contact-us
        </a>
        &nbsp;or call 1300 363 992).
      </p>

      <h3>5. How can I cancel my registration?</h3>

      <p>
        You can cancel your registration at any time. After you have cancelled
        your registration you will not be able to sign into the site to view or
        access any information on the site. Information about you collected on
        the Site prior to your deregistration will continue to be used by us in
        accordance with the Privacy Policy unless you contact us and request
        that we not use it.
      </p>

      <h3>6. How do you keep my information safe?</h3>

      <p>
        We are dedicated to protecting the security of your information and take
        all reasonable precautions to protect it from unauthorised access,
        modification or disclosure. Your electronic information is stored on
        secure servers that are protected in controlled facilities. However, as
        we cannot guarantee the security of communications over the Internet, we
        cannot give an absolute assurance that your information will be secure
        at all times. Transmission of personal information over the Internet is
        at your own risk, and we will not be held responsible for events arising
        from unauthorised access to your personal information.
      </p>

      <h3>7. Future Changes</h3>

      <p>
        As we evolve and introduce new services and features our policies will
        be reviewed and may be revised. We reserve the right to change our
        Privacy Policy at any time and notify you by posting an updated version
        of this policy on our web site. The amended Privacy Policy will apply
        when it is posted on our web site. Please review the Privacy Policy in
        place from time to time and if you don't agree with any part of this
        policy, you should cancel your registration on our site.
      </p>
    </div>
  );
};

export default CareMapprPrivacyDetails;
